/**
 * Redirect to login
 *
 * @param {Vue.$router} router
 * @param {Vue.$route.path|String} currentPath redirect to here if login success
 * @param {Number} [delay=1000]
 */
function redirectToLogin(router, currentPath, delay = 1000) {
  const nextRoute = {
    name: 'login',
  }
  if (currentPath) {
    nextRoute.query = {
      next: window.encodeURIComponent(currentPath),
    }
  }

  window.setTimeout(() => {
    router.push(nextRoute)
  }, delay)
}

function homePageRoute() {
  return { name: 'match-list', query: { isOversea: 'yes' } }
}

function matchBuyRoute(isOversea) {
  return { name: 'match-list', query: { isOversea: isOversea ? 'yes' : 'no' } }
}

/**
 * Change document title
 * Trying to fix WeChat change document.title issue
 * > https://www.zhihu.com/question/27849091/answer/38399344
 *
 * @param {String} title
 */
function changeDocumentTitle(title) {
  setTimeout(() => {
    document.title = title
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.onload = function onload() {
      setTimeout(() => {
        document.body.removeChild(iframe)
      }, 0)
    }
  }, 0)
}

export default {
  redirectToLogin,
  changeDocumentTitle,
  homePageRoute,
  matchBuyRoute,
}



// WEBPACK FOOTER //
// ./client/utils/route-helper.js